import { Button, Flex, Text } from 'rebass';
import React, { useRef } from 'react';
import styled, { keyframes } from 'styled-components';
import { LogoSvg } from './Logo';
import { InputWithLabel } from '../../../components/TextInput';
import { isMobile } from 'react-device-detect';

const slideLeft = keyframes`
  0% {
    opacity: 0;
    transform: translateY(15px);
  };
  100% {
    opacity: 1;
    transform: translateY(0px);
  };
`;

const FootNote = styled(Flex)`
  opacity: 0;
  animation-delay: 1.24s;
  animation-direction: normal;
  animation-duration: 0.4s;
  animation-fill-mode: forwards;
  animation-iteration-count: 1;
  animation-name: ${slideLeft};
  animation-play-state: running;
  animation-timing-function: cubic-bezier(0.64, 0, 0.28, 1);
  box-sizing: border-box;
  flex: 1;
  flex-direction: column;
  justify-content: flex-end;
`;

export const HeightWeight = ({ title, state, id, onChange, onContinue }) => {
  const HeightRef = useRef(null);
  const InchesRef = useRef(null);
  const WeightRef = useRef(null);

  const handleHeightClick = () => {
    if (HeightRef.current) {
      HeightRef.current.focus();
    }
  };
  const handleInchesClick = () => {
    if (InchesRef.current) {
      InchesRef.current.focus();
    }
  };
  const handleWeightClick = () => {
    if (WeightRef.current) {
      WeightRef.current.focus();
    }
  };

  return (
    <Flex flex={1} flexDirection={'column'}>
      <LogoSvg />
      <Text style={{ fontSize: isMobile ? '26px' : '32px', fontWeight: 500 }} mb={4}>
        What is your Height and Weight:
      </Text>

      <Flex flexDirection={'column'} mb={3}>
        <Text mb={2} fontSize={'14px'} fontWeight={500}>
          Your Height
        </Text>
        <Flex flexDirection={['column', 'row']}>
          <Flex
            flexDirection={'row'}
            onClick={handleHeightClick}
            style={{ border: `1px solid #909ebb`, borderRadius: '12px', padding: '12px 0px 0px 0px', background: 'white', cursor: 'pointer', alignItems: 'center' }}
          >
            <Flex flex={1} flexDirection={'column'}>
              <InputWithLabel
                placeholder="Feet"
                style={{ border: 0, background: 'white', color: '#344f79', fontSize: isMobile?'14px':'' }}
                subref={HeightRef}
                value={state['feet']}
                type={'number'}
                inputMode='numeric'
                onChange={(e) => {
                  onChange('feet', e.target.value);
                }}
              />
            </Flex>
          </Flex>
          <Flex
            flexDirection={'row'}
            ml={[0, 3]}
            mt={[3, 0]}
            onClick={handleInchesClick}
            style={{ border: `1px solid #909ebb`, borderRadius: '12px', padding: '12px 0px 0px 0px', background: 'white', cursor: 'pointer', alignItems: 'center' }}
          >
            <Flex flex={1} flexDirection={'column'}>
              <InputWithLabel
                placeholder="Inches"
                style={{ border: 0, background: 'white', color: '#344f79', fontSize: isMobile?'14px':'' }}
                subref={InchesRef}
                value={state['inches']}
                type={'number'}
                inputMode='numeric'
                onChange={(e) => {
                  onChange('inches', e.target.value);
                }}
              />
            </Flex>
          </Flex>
        </Flex>
      </Flex>

      <Flex flexDirection={'column'}>
        <Text mb={2} fontSize={'14px'} fontWeight={500}>
          Your Weight
        </Text>
        <Flex flexDirection={['column', 'row']}>
          <Flex
            flexDirection={'row'}
            onClick={handleWeightClick}
            style={{ border: `1px solid #909ebb`, borderRadius: '12px', padding: '12px 0px 0px 0px', background: 'white', cursor: 'pointer', alignItems: 'center' }}
          >
            <Flex flex={1} flexDirection={'column'}>
              <InputWithLabel
                placeholder="Pounds (lbs)"
                style={{ border: 0, background: 'white', color: '#344f79', fontSize: isMobile?'14px':'' }}
                subref={WeightRef}
                value={state['pounds']}
                type={'number'}
                inputMode='numeric'
                onChange={(e) => {
                  onChange('pounds', e.target.value);
                }}
              />
            </Flex>
          </Flex>
        </Flex>
      </Flex>

      <FootNote mb={4}>
        <Button variant={'primary'} onClick={onContinue} disabled={(!(state || {})['pounds'] && !(state || {})['pounds']!==0) || (!(state || {})['inches'] && !(state || {})['inches']!==0) || (!(state || {})['feet'] && !(state || {})['feet']!==0)}>
          Continue
        </Button>
      </FootNote>
    </Flex>
  );
};
